import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getPickupRevenue,getPickupRevenuebyId,exportPickupRevenue,getDeliveryRevenue,getDeliveryRevenuebyId,
   exportDeliveryRevenue,getFailedInvoices,getFailedRevenue,getStaging,getPendingCalculation,pushStageInvoices,pushInvoices,rePushInvoice,revenueRecalculation,stageRevenueRecalculation,
  getRefunds,getInvoiceStatus,RevenueRecalculationAll,stageRevenueRecalculationAll,pushAllInvoices,pushAllStageInvoices,getRefundbyId,getTransactionsbyId,exportRefund,postRefund,deleteRefund,uploadRefund,downloadRefundProof,getStatus} from "../../services/RevenueMgt/Revenue_services";
const initialValues = {
   statusList: [],
   InvoiceStatusList: []
};
let revenueStore = (set) => ({
  ...initialValues,
  getPickupRevenue: async (params) => {
        const response = await getPickupRevenue(params);
        return response;
      },
      getPickupRevenuebyId: async (params) => {
         const response = await getPickupRevenuebyId(params);
         return response;
       },
      exportPickupRevenue: async (params) => {
        const response = await exportPickupRevenue(params);
        return response;
      },
      getDeliveryRevenue: async (params) => {
        const response = await getDeliveryRevenue(params);
        return response;
      },
      getDeliveryRevenuebyId: async (params) => {
         const response = await getDeliveryRevenuebyId(params);
         return response;
       },
      exportDeliveryRevenue: async (params,data) => {
        const response = await exportDeliveryRevenue(params,data);
        return response;
      },
       getFailedInvoices: async (params) => {
         const response = await getFailedInvoices(params);
         return response;
       },
        getFailedRevenue: async (params) => {
         const response = await getFailedRevenue(params);
         return response;
       },
        pushInvoices: async (data) => {
         const response = await pushInvoices(data);
         return response;
       },
        rePushInvoice: async (data) => {
         const response = await rePushInvoice(data);
         return response;
       },
        pushAllInvoices: async (data) => {
         const response = await pushAllInvoices(data);
         return response;
       },
        pushAllStageInvoices: async (data) => {
         const response = await pushAllStageInvoices(data);
         return response;
       },
           getStaging: async (params) => {
         const response = await getStaging(params);
         return response;
       },
          getPendingCalculation: async (params) => {
         const response = await getPendingCalculation(params);
         return response;
       },
           pushStageInvoices: async (data) => {
         const response = await pushStageInvoices(data);
         return response;
       },
        revenueRecalculation: async (data) => {
         const response = await revenueRecalculation(data);
         return response;
       },
          stageRevenueRecalculation: async (data) => {
         const response = await stageRevenueRecalculation(data);
         return response;
       },
         getRefunds: async (data) => {
         const response = await getRefunds(data);
         return response;
       },
         getRefundbyId: async (data) => {
         const response = await getRefundbyId(data);
         return response;
       },
         getTransactionsbyId: async (data) => {
         const response = await getTransactionsbyId(data);
         return response;
       },
         exportRefund: async (data) => {
         const response = await exportRefund(data);
         return response;
       },
         stageRevenueRecalculationAll: async (data) => {
         const response = await stageRevenueRecalculationAll(data);
         return response;
       },
         RevenueRecalculationAll: async (data) => {
         const response = await RevenueRecalculationAll(data);
         return response;
       },
         postRefund: async (data) => {
         const response = await postRefund(data);
         return response;
       },
         deleteRefund: async (data) => {
         const response = await deleteRefund(data);
         return response;
       },
         uploadRefund: async (params,data) => {
         const response = await uploadRefund(params,data);
         return response;
       },
         downloadRefundProof: async (params) => {
         const response = await downloadRefundProof(params);
         return response;
       },
        getStatus: async () => {
         const response = await getStatus();
         set({ statusList: response });
         return response;
       },
        getInvoiceStatus: async () => {
         const response = await getInvoiceStatus();
         set({ InvoiceStatusList: response });
         return response;
       },
});

revenueStore = devtools(revenueStore);

export const useRevenueStore = create(revenueStore);